module.exports = __webpack_public_path__ + "media/assets/community/linkedin-logo-4b077673e8fba1cd281f27f20a57266486530e8b651c17742e8a9ef24591431c.png";